import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Spin } from 'antd'
import { ShoppingOutlined } from '@ant-design/icons'
import OrderForm from '../OrderForm'
import { ProductListContext } from '../../contexts'

const ProductDetail = ({ product }) => {
  const {
    setFormModalVisible,
    formModalVisible,
    isLoading
  } = useContext(ProductListContext)

  const _onCloseForm = () => {
    setFormModalVisible(false)
  }

  const _onOpenForm = () => {
    setFormModalVisible(true)
  }

  return isLoading ? (
    <Spin/>
  ) : (
    <div className="product-list-container">
      <Button type="primary" onClick={_onOpenForm}>
        <ShoppingOutlined className="cart-icon"/> Order Now
      </Button>
      <Modal
        visible={formModalVisible}
        width={window.innerWidth - 100}
        style={{ top: 20, height: '100%' }}
        centered={true}
        footer={null}
        onCancel={_onCloseForm}
      >
        <OrderForm product={product}/>
      </Modal>
    </div>
  )
}

ProductDetail.propTypes = {
  product: PropTypes.string
}

export default ProductDetail
